// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ftr[data-v-24bcf655]{margin-top:2.5rem}.loading[data-v-24bcf655]{display:none}@media (min-width:960px){.ftr[data-v-24bcf655]{margin-top:3rem}}@media (max-width:959px){.page[data-v-24bcf655]:not(.page--full){height:100%}}", ""]);
// Exports
module.exports = exports;
